import axios from '@/libs/api.request'
// 角色列表
export const roleList = data => {
    return axios.request({
      url: '/sys/role/list',
      method: 'get',
      data,
    })
  }
  // 角色信息
export const roleInfo = data => {
    return axios.request({
      url: `/sys/role/info/${data.roleId}`,
      method: 'get',
      data,
    })
  }
  // 自己所拥有的角色列表
export const roleSelect = data => {
    return axios.request({
      url: '/sys/role/select',
      method: 'get',
      data,
    })
  }
    // 删除角色
export const roleDelete = data => {
    return axios.request({
      url: '/sys/role/delete',
      method: 'post',
      data,
    })
  }
      // 保存角色
export const roleSave = data => {
    return axios.request({
      url: '/sys/role/save',
      method: 'post',
      data,
    })
  }

        // 修改角色
export const roleUpdate = data => {
    return axios.request({
      url: '/sys/role/update',
      method: 'post',
      data,
    })
  }